    export default class MultipleOptionsValidator {
        constructor(options) {
            this._options = options;
        }

        isValid(value) {
            if (!value) return false;
            const values = Array.isArray(value) ? value : [value];
            return values.every((option) =>
                this._options.some((validOption) => validOption === option.value)
            );
        }

        errorMessage() {
            return "Opción inválida";
        }
    }